import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import voca from 'voca';

import { currencyCodes } from 'components/helpers/currency';

export default function CurrencyField({
  currencyCode = 'GBP',
  fieldError,
  isRequired = false,
  label,
  name,
  onChange,
  removeErrorStyling,
  value,
}) {
  const separatorRegex = new RegExp(
    `^\\d+(\\${currencyCodes[currencyCode].separator}\\d{0,2})?`,
  );

  const handleInputChange = (event) => {
    onChange(event, (value) => {
      const matchedValue = value.match(separatorRegex);

      return matchedValue ? matchedValue[0] : '';
    });
  };

  const isInvalid = !!fieldError?.fieldHighlighted;

  return (
    <div className='text-field'>
      <div className='form-group'>
        <label className='field__label tw-font-medium' htmlFor={name}>
          {label} {isRequired && '*'}
        </label>
        <div className='field__input-container tw-relative tw-flex tw-items-center'>
          <div className='tw-absolute tw-left-3 tw-top-[10px] tw-ml-[1px] tw-mt-[1px]'>
            {currencyCodes[currencyCode].unit}
          </div>
          <input
            className={classNames(
              'field__input tw-pl-7 tw-font-inter tw-text-m tw-font-normal tw-tracking-auto',
              isInvalid ?
                'tw-border-red-600 focus-within:tw-border-red-600 hover:tw-border-red-600 hover:focus-within:tw-border-red-600'
              : 'tw-border-grey-300 placeholder:tw-text-grey-300 focus-within:tw-border-blue-300 hover:tw-border-grey-400 hover:focus-within:tw-border-blue-300',
            )}
            id={voca.snakeCase(name)}
            name={name}
            onChange={handleInputChange}
            onFocus={removeErrorStyling}
            type='text'
            value={value}
          />
        </div>
      </div>
    </div>
  );
}

CurrencyField.propTypes = {
  currencyCode: PropTypes.string,
  fieldError: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  removeErrorStyling: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
